var exports = {
  "zr": "xa15a2ab7--160cea--root",
  "DD": "xa15a2ab7--160cea--title",
};

module.exports = exports;
